<template>
  <div class="header">
      <app-icon :src="icon" size="57px" />

      <div class="header__info">
          <p class="title">
             {{ name }}
          </p>

          <p class="g-text">{{ description }}</p>
      </div>
  </div>
</template>

<script>
import AppIcon from '@/components/AppIcon.vue';

export default {
  props: {
    icon: String,
    name: String,
    description: String,
  },
  components: { AppIcon },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  gap: 10px;

  &__info {
      display: flex;
      flex-direction: column;
      gap: 5px;
  }
}

.title {
    font-size: 16px;
    font-weight: 500;
    padding-right: 15px;
}
</style>
